import React, { useContext, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import {
  Select,
  MenuItem,
  FormControl,
  FormControlLabel,
  TextField,
  Radio,
  Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import ButtonTheme from "../../ThemeButton/ThemeButton";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useDispatch, useSelector } from "react-redux";
import ApiService from "../../../functions/apiService";
import { setDashboardEmployeeToSwap } from "../../../store/dashboardReducer";
import Error from "../../Error/Error";
import { toast } from 'react-toastify';

export default function SetLocks() {
  // const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  let EmployeeToSwap = useSelector(
    (state) => state.dashboardReducer.EmployeeToSwap
  );
  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
    setError,
    setValue,
    getValues,
    reset,
    watch,
  } = useForm({
    defaultValues: {
      type: "RTO_VAC",
      userId: "all",
    },
  });
  let submitAction = (body, action) => {
    if (body.userId == "all") {
      body.allUser = true;
    } else {
      body.allUser = false;
    }
    body.action = action;
    body.function = "LOCKOUT";
    // console.log('body', body);
    setLoading(true);
    ApiService.post("/postUserLock", body)
      .then(({ data }) => {
        setLoading(false);
        toast.success('Success')
        // enqueueSnackbar("success", { variant: "success" });
      })
      .catch(({ data }) => {
        setLoading(false);
        toast.error('Error')
        // enqueueSnackbar("Error", { variant: "error" });
      });
  };
  const onSubmit = (body) => {
    submitAction(body, "set");
  };
  const onSubmitDelete = (body) => {
    submitAction(body, "delete");
  };
  useEffect(() => {
    ApiService.get("/employeeToSwap", {}, "employeeToSwap")
      .then(({ data }) => {
        dispatch(setDashboardEmployeeToSwap(data));
      })
      .catch(() => {
        toast.error('Error')
        // enqueueSnackbar("Error", { variant: "error" });
      });
  }, []);

  return (
    <>
      <Typography fontWeight="700" fontSize="16px">
        {" "}
        Set Locks
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)} className="row">
        <div className="col-12 col-md-6 col-lg-3 mt-2">
          {EmployeeToSwap && EmployeeToSwap.length > 0 && (
            <FormControl
              required={true}
              fullWidth
            >
              <label style={{ fontSize: '14px' }}>Employee</label>
              <Select className="mt-2"
                sx={{
                  height: '48px',
                  "& .MuiSelect-select": {
                    display: "flex",
                    alignItems: "center",
                  },
                }}
                MenuProps={{ disableScrollLock: true }}
                defaultValue="all"
                {...register("userId", { required: "user  is required." })}
              >
                <MenuItem value="all">AllEmployee </MenuItem>
                {EmployeeToSwap?.map((option) => (
                  <MenuItem value={option.Emp_Code} key={option.Emp_Code}>
                    {option.EA_Rank + " " + option.fullName}{" "}
                  </MenuItem>
                ))}
              </Select>
              {errors.userId && <Error>{errors.userId?.message}</Error>}
            </FormControl>
          )}
        </div>

        <div className="col-12 col-md-6 col-lg-3 mt-2">
          <FormControl
            required={true}
            fullWidth
          >
            <label style={{ fontSize: '14px' }}>Type</label>
            <TextField
              className="mt-2"
              InputProps={{
                sx: {
                  height: '48px',
                }
              }}
              sx={{ "& .MuiInputBase-input": { height: "39px" } }}
              size="small"
              {...register("type", { required: "type  is required." })}
            />
            {errors.type && <Error>{errors.type?.message}</Error>}
          </FormControl>
        </div>
        <div className="col-12 mt-3">
          <ButtonTheme disabled={loading} color="primary" type="submit">
            Set Lock
          </ButtonTheme>
          <ButtonTheme
            disabled={loading}
            color="primary"
            type="buuton"
            onClick={onSubmitDelete}
            className="mx-2"
          >
            Delete Lock
          </ButtonTheme>
        </div>
      </form>
    </>
  );
}
